import { copies } from '@reveni-io/reveni-ui'

import { refundMethodConfig } from './constants'

const resolveCopySources = (refundType, isInstant) => {
  const config = refundMethodConfig[refundType]

  return isInstant ? config?.instant : config?.normal
}

export const resolveMethodName = (refundMethod, refundType, t) => {
  return refundMethod?.display || t(refundMethodConfig[refundType]?.defaultName)
}

export const resolveMethodIcon = refundType => refundMethodConfig[refundType]?.Icon

export const resolveDescription = (refundType, isInstant, lang) => {
  const copySources = resolveCopySources(refundType, isInstant)

  return copies[lang].requestSummary[copySources?.defaultCopyKey]
}

export const resolveCustomCopyKey = (refundType, isInstant) => {
  const copySources = resolveCopySources(refundType, isInstant)

  return copySources?.customCopyKey
}

export const getFormattedAmount = ({ currency, storeCurrency, amount = 0, amountInStoreCurrency = 0, language }) => {
  const formattedAmount = new Intl.NumberFormat(language, { style: 'currency', currency }).format(amount)
  const formattedAmountInStoreCurrency = new Intl.NumberFormat(language, {
    style: 'currency',
    currency: storeCurrency,
  }).format(amountInStoreCurrency)

  if (currency === storeCurrency) {
    return formattedAmount
  } else {
    return `${formattedAmountInStoreCurrency} (${formattedAmount})`
  }
}
